
export class Date_Util {

    static undef;

    public static humanYmdRead(strTS) {
        let ret     = strTS;
        if (ret.length === 19) {
            ret     = ret.substr(0, 10);
        }
        return  ret;
    }

    public static humanRead(strTS) {
        let ret     = strTS;
        if (ret.length === 19) {
            ret     = ret.substr(5, 11);
        }
        return  ret;
    }

    public static smartHumanRead(strTS, acc = false) {
        let res = this.calcHumanRead(strTS, acc);
        return  res.before;
    }

    // 刚刚、N分钟前，N小时前，N天前，m月d日
    // 如果设置了 accurate = true，则"刚刚"会改为精确到秒
    public static calcHumanRead(strTS, accurate = false) {
        let intNow  = this.time();
        let intIn   = this.strtotime(strTS);
        let duration    = intNow - intIn;

        let length_month    = 86400 * 30;
        let length_day      = 86400 * 3;
        let length_by       = 86400 * 2;
        let length_yes      = 86400 * 1;
        let length_hour     = 3600;
        let length_min      = 60;

        let before  = '';
        let int     = 0;
        if (duration >= length_month) {
            before      = this.date('n月j日', intIn);
        } else if (duration >= length_day) {
            int         = Math.floor(duration / 86400);
            before      = `${int}天前`;
        } else if (duration >= length_yes) {
            // 最复杂的区间，计算昨天还是前天
            // 日期之间的差别，单位：秒
            let time_of_days_diff   = this.strtotime(this.date('Y-m-d', intNow)) -
                                        this.strtotime(this.date('Y-m-d', intIn));
            // 日期之间的差别，单位：天
            let int_days_diff   = Math.floor(time_of_days_diff / 86400);
            if (int_days_diff <= 1) {
                before      = `昨天`;
            } else {
                before      = `前天`;
            }

        } else if (duration >= length_hour) {
            int         = Math.floor(duration / length_hour);
            before      = `${int}小时前`;
        } else if (duration > length_min) {
            int = Math.floor(duration / length_min);
            before = `${int}分钟前`;
        } else if (accurate && duration > 0) {
            before = `${duration}秒前`;
        } else {
            before      = '刚刚';
        }

        let ret = {
            duration:   duration,
            before:     before,
            int_now:    intNow,
            int_input:  intIn
        };

        return  ret;
    }

    public static durationToHuman(intDuration) {
        intDuration     = Math.floor(intDuration);
        let int_hours   = Math.floor(intDuration / 3600);
        let mins        = intDuration % 3600;
        let int_min     = Math.floor(mins / 60);
        let parts       = [];
        if (int_hours > 0) {
            parts.push(int_hours + '小时');
        }
        if (int_min > 0) {
            parts.push(int_min + '分钟');
        }
        let ret = parts.join('');
        return ret;
    }

    public static strtotime(str) {
        if (-1 === str.indexOf('-')) {
            str = ([
                str.substr(0, 4),
                str.substr(4, 2),
                str.substr(6, 2)
            ]).join('-');
        }
        if (str.length <= 10) {
            str     += ' 00:00:00';
        }
        str = str.replace(' ', 'T');
        str += '.000+08:00';
        let time_int    = Math.floor(Date.parse(str) / 1000);
        return  time_int;
    }

    public static paddingZero(str) {
        return (parseInt(str) + 0 + 100).toString().substr(1, 2);
    }

    public static getDateObject() {
        let ret;
        ret     = new Date();
        if (window && this.undef != window['CUSTOMIZED_DATE_NOW']) {
            let time = this.strtotime(window['CUSTOMIZED_DATE_NOW']);
            ret     = new Date(time * 1000);
        }
        return  ret;
    }

    public static time() {
        return  this.strtotime(this.date('Y-m-d H:i:s', null));
    }

    public static date(fmt, time) {
        let obj     = time ? new Date(time * 1000) : this.getDateObject();
        let str     = fmt;
        str         = str.replace('Y', obj.getFullYear());
        str         = str.replace('m', (parseInt(obj.getMonth()) + 1 + 100).toString().substr(1, 2));
        str         = str.replace('d', (parseInt(obj.getDate()) + 0 + 100).toString().substr(1, 2));
        str         = str.replace('n', (parseInt(obj.getMonth()) + 1));
        str         = str.replace('j', (parseInt(obj.getDate())));
        str         = str.replace('H', this.paddingZero(obj.getHours()));
        str         = str.replace('i', this.paddingZero(obj.getMinutes()));
        str         = str.replace('s', this.paddingZero(obj.getSeconds()));
        return str;
    }

    public static jsTsToDate(intTs) {
        let int_second  = intTs / 1000;
        let date = this.date('Y-m-d', int_second);
        return  date;
    }

}


